<template>
    <div class="wrapper" :class="{'sidebar-mini' : sidebar.mini, 'nav-open' : sidebar.mobile}">
        <siderbar/>
        <div class="main-panel" style="min-height: 100vh">
            <navbar/>
            <div class="content">
                <router-view></router-view>
            </div>
            <div class="close-layer visible" v-if="sidebar.mobile" @click="sideBarToggleMobile"></div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import Siderbar from '@/components/layout/Sidebar'
    import Navbar from '@/components/layout/Navbar'

    export default {
        components: {
            Siderbar,
            Navbar
        },
        computed: {
            ...mapState(['sidebar'])
        },
        methods: {
            sideBarToggleMobile() {
                this.$store.dispatch('sideBarToggleMobile');
            }
        }
    }
</script>
